'use strict';

class ReconfirmacionUsuarioController {
  constructor(
    $uibModalInstance, 
    DataService, 
    _, 
    Util, 
    Message, 
    data,
    Integracion

    ) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.DataService = DataService;
    this._ = _;
    this.Util = Util;
    this.Message = Message;
    this.usuario = data.usuario;
    this.apiExtra = data.apiExtra;
    this.Integracion = Integracion;
  }

  $onInit() {
    this.url = this.apiExtra? this.apiExtra : `usuario/reenviar-confirmacion`;
  }

  reenviarCorreo() {
    
    const reset={
      usuario: this.usuario.id_usuario,
      name: this.usuario.usuario || this.usuario.persona.numero_documento ,
      pass: Array.from(
        window.crypto.getRandomValues(new window.Uint8Array(10))
      )
      .map(x => (x % 36).toString(36))
      .join(''),
      mail:this.usuario.persona.correo,
    }

    // console.log('datos usuario',this.usuario);
    // console.log('datos usuario2',reset);

    
    const dts=this.Integracion.resetMail(reset)
     dts.then(function successCallback(respuesta){
       return respuesta.data;      
     })
     .then((dts)=>{ 
        if (dts.estado=='CORRECTO'){
          this.Message.success('Se remitio el correo de forma correcta');
          this.$uibModalInstance.close(true);
        }
       //console.log('respuesta ',dts); 
       //this.Message.warning(dts,`Importacion Cómputos Metricos`,12000);
       
      })
      
      

    // this.DataService.post(this.url, {correo: this.usuario.persona.correo, id_usuario: this.usuario.id_usuario}).then(response => {
    //   if (response && response.finalizado) {
    //     this.Message.success(response.mensaje);
    //     this.$uibModalInstance.close(true);
    //   }
    // });
  }

  cerrar() {
    this.$uibModalInstance.close(false);
  }

}

export default ReconfirmacionUsuarioController;



// WEBPACK FOOTER //
// ./src/app/components/admin/usuarios/reenviar-confirmacion/reconfirmacion.modal.controller.js